import Header from './components/Header';
import Hero from './components/Hero';
import ContactSection from './components/ContactSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import FAQSection from './components/FAQSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <ContactSection />
        <FeaturesSection />
        <TopicsSection />
        <UpdatesSection />
        <AppSection />
        <FAQSection />
        <MediaSection />
        <CardsSection />
        <CommentsSection />
        <RankingSection />
        <IndexSection />
        <AboutSection />
        <CarouselSection />
      </main>
      <Footer />
    </>
  );
}